import { Icon } from "./Icon.tsx";

/** "Download" icon for icon-only buttons (e.g. export CSV). */
export function DownloadIcon() {
  return (
    <Icon>
      <path d="M12 3v12" />
      <path d="M7 10l5 5 5-5" />
      <path d="M4 19h16" />
    </Icon>
  );
}
